import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductUid } from '../../domain/models/related-products.models';
import { florenProductsTransformer } from '../transformers/floren.transformer';

import { MocacoAttributesPublicFunctions } from '@features/products/mocaco-attributes';
import { ProductPublicModels } from '@features/products/product';
import { StaticResourceService } from '@shared/services/static-resources/static-resource.service';

export const getRelatedProductsFromFlorenUseCase = (
    staticResourceService: StaticResourceService,
    baseProduct: ProductPublicModels.PublicProduct
): Observable<ProductUid[]> => {
    const mocaco = MocacoAttributesPublicFunctions.GetMocacoCode(baseProduct);
    const target = 'related_buyed';

    return staticResourceService.getRelateds(target).pipe(
        map((relatedProductsRaw) => {
            const florenProductInfo = relatedProductsRaw[mocaco];
            if (!florenProductInfo) {
                return [];
            }
            return florenProductsTransformer(florenProductInfo.floren);
        })
    );
};

export const filterProductsWithStockFloren = (
    products: ProductPublicModels.PublicProduct[]
): ProductPublicModels.PublicProduct[] => {
    return products.filter((product) => product.status.selectedColor.sizes.filter(size => size.visibilityValue !== 'HIDDEN').length > 0);
};
